module.exports = __webpack_public_path__ + "static/3-ad690376eb5d279e0de927b53b517efa.png";